
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const PrivacyPolicyViewer = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Privacy Policy</CardTitle>
        <CardDescription>
          Last updated: {new Date().toLocaleDateString()}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 max-h-96 overflow-y-auto">
        <div>
          <h3 className="text-lg font-semibold mb-3">1. Information We Collect</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <p><strong>Personal Information:</strong> When you create an account, we collect your email address, username, and any profile information you provide.</p>
            <p><strong>Content Data:</strong> We store the notes, groups, and other content you create using our service.</p>
            <p><strong>Usage Data:</strong> We may collect information about how you use our service, including device information, IP address, and browser type.</p>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-lg font-semibold mb-3">2. How We Use Your Information</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <p>• To provide and maintain our service</p>
            <p>• To notify you about changes to our service</p>
            <p>• To provide customer support</p>
            <p>• To gather analysis or valuable information to improve our service</p>
            <p>• To monitor the usage of our service</p>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-lg font-semibold mb-3">3. Your Rights Under GDPR</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <p><strong>Right to Access:</strong> You can request copies of your personal data.</p>
            <p><strong>Right to Rectification:</strong> You can request correction of inaccurate data.</p>
            <p><strong>Right to Erasure:</strong> You can request deletion of your personal data.</p>
            <p><strong>Right to Restrict Processing:</strong> You can request restriction of processing.</p>
            <p><strong>Right to Data Portability:</strong> You can request transfer of your data.</p>
            <p><strong>Right to Object:</strong> You can object to processing of your personal data.</p>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-lg font-semibold mb-3">4. Your Rights Under CCPA</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <p><strong>Right to Know:</strong> You can request information about what personal information we collect.</p>
            <p><strong>Right to Delete:</strong> You can request deletion of your personal information.</p>
            <p><strong>Right to Opt-Out:</strong> You can opt-out of the sale of personal information.</p>
            <p><strong>Right to Non-Discrimination:</strong> We won't discriminate against you for exercising your privacy rights.</p>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-lg font-semibold mb-3">5. Data Security</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
            <p>Your data is encrypted in transit and at rest using industry-standard encryption methods.</p>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-lg font-semibold mb-3">6. Data Retention</h3>
          <div className="text-sm text-gray-600 space-y-2">
            <p>We retain your personal information only for as long as necessary to provide you with our service and as described in this Privacy Policy.</p>
            <p>We will also retain and use your information as necessary to comply with legal obligations, resolve disputes, and enforce our agreements.</p>
          </div>
        </div>

        <Separator />

        <div>
          <h3 className="text-lg font-semibold mb-3">7. Contact Us</h3>
          <div className="text-sm text-gray-600">
            <p>If you have any questions about this Privacy Policy or want to exercise your privacy rights, please contact our Data Protection Officer at:</p>
            <p className="mt-2">
              <strong>Email:</strong> hello@mindnote.online<br />
              <strong>Address:</strong> Santo Domingo 10112, Dominican Republic
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PrivacyPolicyViewer;
